export default __webpack_public_path__ + "static/media/CanteenModule.316dd0a9.svg";